import { render } from "./TileDashboard.vue?vue&type=template&id=345718f2"
import script from "./TileDashboard.vue?vue&type=script&lang=js"
export * from "./TileDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__